import React from 'react';
const LicenseGate = ({ children }) => children;
export default LicenseGate;
